<!-- 关于企业出海 -->
<template>
  <div class="Accelerator fd_column">
    <div class="m-b-30">
      <div class="title_mid">
        <img src="@/assets/home/gecInitiative.png" alt="" />
        <div @click="toRouterPush('/Accelerator')" class="more">
          <div>VIEW MORE</div>
          <img src="@/assets/home/arrow-right-up-line.png" alt="" />
        </div>
      </div>
    </div>
    <div class="component_box">
      <div class="vertical-item">
        <img :src="bgImgUrl" alt="" />
      </div>
      <!-- <div
        class="vertical-item"
        :style="{
          backgroundImage: 'url(' + bgImgUrl + ')',
          backgroundSize: '100% 100%',
        }"
      >
        <div v-if="windowWidth > 1024">
          <div class="vertical-item-title">Vertical Hubs</div>
          <div class="vertical-item-content">
            Vertical accelerator systems include：Vertical acceleration
            industries
          </div>
          <div class="vertical-item-content">
            Vertical acceleration mechanism The number of industry experts
          </div>
          <div class="vertical-item-content">
            The number of implemented projects
          </div>
          <div class="vertical-item-more">View more</div>
        </div>

        <div v-else class="vertical-item-content-mo">
          <div class="vertical-item-title">Vertical Hubs</div>
          Vertical accelerator systems include：Vertical acceleration industries
          Vertical acceleration mechanism The number of industry experts The
          number of implemented projects
          <div class="vertical-item-more">View more</div>
        </div>
      </div> -->
      <div class="vertical-item-box">
        <div class="item">
          <img src="@/assets/home/verticalIco3.png" alt="" />
          <div class="number">{{ listData[0].theValue }}<span>+</span></div>
          <div class="content">GEC Members in the <br />First Cohort</div>
        </div>
        <div class="item">
          <img src="@/assets/home/verticalIco2.png" alt="" />
          <div class="number">{{ listData[1].theValue }}<span>+</span></div>
          <div class="content">
            Shanghai Districts Covered <br />
            by GEC Members
          </div>
        </div>
        <div class="item">
          <img src="@/assets/home/verticalIco5.png" alt="" />
          <div class="number">{{ listData[2].theValue }}<span>+</span></div>
          <div class="content">
            Linkages with Academic <br />
            Institutions
          </div>
        </div>
        <div class="item">
          <img src="@/assets/home/verticalIco1.png" alt="" />
          <div class="number">{{ listData[3].theValue }}<span>+</span></div>
          <div class="content">
            Linkages with Corporations <br />
            & Enterprises
          </div>
        </div>
        <div class="item">
          <img src="@/assets/home/verticalIco4.png" alt="" />
          <div class="number">
            {{ listData[4].theValue }}
            <span>+</span>
          </div>
          <div class="content">
            Linkages with Investment <br />
            Institutions
          </div>
        </div>
        <div class="item">
          <img src="@/assets/home/verticalIco6.png" alt="" />
          <div class="number">
            {{ listData[5].theValue }}
            <span>+</span>
          </div>
          <div class="content">
            Linkages with Overseas <br />
            Partners
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { CoogetList, getVerticalImage } from "@/api/Accelerator/Accelerator";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      listData: [],
      bgImgUrl: require("@/assets/home/verticalBg.png"),
      windowWidth: null,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    handleScroll() {
      this.windowWidth = window.innerWidth;
    },
    async getList() {
      const res = await CoogetList();
      if (res.code === 1) {
        this.listData = res.data;
      }
    },
    async getVerticalImage() {
      try {
        const res = await getVerticalImage();
        if (res.code === 1 && res.data && res.data.imgUrl) {
          this.bgImgUrl = process.env.VUE_APP_BASE_IMAGE + res.data.imgUrl;
        }
      } catch (error) {
        console.error("获取背景图片失败:", error);
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
    this.getVerticalImage();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.handleScroll();
    window.addEventListener("resize", this.handleScroll);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {
    window.removeEventListener("resize", this.handleScroll);
  }, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";
</style>

<style lang="less" scoped>
@media screen and (min-width: 750px) {
  @import "./AcceleratorPc.less";
}
@media screen and (max-width: 750px) {
  @import "./AcceleratorMo.less";
}
</style>
